export const getTariffTranslationKey = (tariff) => {
    return `tariff_${ tariff }`
}